export default __webpack_public_path__ + "static/media/communityworker.220bfe80.png";